export enum LibraryEnum {
    cognito = "idp.cognito.active",
    okta = "idp.okta.active",
    cirrus = "idp.cirrus.active",
    globalEnable = 'global.enabled'
}